import {ElementRef, Input, Component, Output, EventEmitter, HostListener, HostBinding} from '@angular/core';
import { LoggerService } from '../logger-service/logger.service';

@Component({
    selector: 'resizable', // tslint:disable-line
    template: `
        <ng-content></ng-content>
        <div class=grabber [ngClass]="dir" *ngFor="let dir of directions" (mousedown)="onResizeStart($event, dir)"></div>
    `,
    styleUrls: ['../../assets/theme/css/Resizable.css'],
})
export class ResizableComponent {
    @Input() public directions: Array<string>;
    @Output() public onResizeEvent: EventEmitter<any> = new EventEmitter();

    private _direction: string;
    private _start: number;
    private _width: number;
    private _height: number;
    @HostBinding('style.height') height: string;
    @HostBinding('style.width') width: string = '';

    constructor(private element: ElementRef, private _logger: LoggerService) { }

    public onResizeStart(event: MouseEvent, direction: string) {
        this._direction = direction;
        this._start = this.isHorizontalResize(this._direction) ? this.getClientX(event) : this.getClientY(event);
        this._width = this.element.nativeElement.clientWidth;
        this._height = this.element.nativeElement.clientHeight;

        if (event.stopPropagation) {
            event.stopPropagation();
        }
        if (event.preventDefault) {
            event.preventDefault();
        }
        event.cancelBubble = true;
        event.returnValue = false;

        this._logger.debug('ResizableComponent', 'starting resize: ' + this._direction + ' ' + this._start);
    }

    @HostListener('document:mouseup', ['$event'])
    onResizeEnd() {
        if (this._direction) {
            this._logger.debug('ResizableComponent', 'onResizeEnd');
            this._direction = undefined;
            this._start = 0;
        }
    }

    @HostListener('document:mousemove', ['$event'])
    onResize(event: MouseEvent) {
        if (!this._direction) {
            return;
        }

        let offset = this.isHorizontalResize(this._direction) ? this._start - this.getClientX(event) : this._start - this.getClientY(event);
        if (offset === 0) {
            return;
        }

        if (this._direction === 'bottom') {
            this.height = this._height - offset + 'px';
        } else if (this._direction === 'left') {
            this.width = this._width + offset + 'px';
        } else if (this._direction === 'right') {
            this.width = this._width - offset + 'px';
        }

        this.onResizeEvent.emit(this.width);
    }

    private isHorizontalResize(direction: string) {
        return direction === 'left' || direction === 'right';
    };

    private getClientX(event: MouseEvent | TouchEvent) {
        if (event instanceof MouseEvent) {
            return (event as MouseEvent).clientX;
        } else {
            return (event as TouchEvent).touches[0].clientX;
        }
    };

    private getClientY(event: MouseEvent | TouchEvent) {
        if (event instanceof MouseEvent) {
            return (event as MouseEvent).clientY;
        } else {
            return (event as TouchEvent).touches[0].clientY;
        }
    };

}
